import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';
import React, { FC } from 'react';

import { SpinWrapper } from './styled';

const Loader: FC<Props> = props => {
  const { type, size, ...rest } = props;
  return (
    <SpinWrapper type={type}>
      <Spin {...rest} size={size || 'large'} />
    </SpinWrapper>
  );
};

export default Loader;

export interface Props extends SpinProps {
  type?: 'start';
}
